import React, { useEffect } from "react";
import * as Yup from "yup";
import FormField from "Components/Forms/FormComponent/FormFiled";
import InputFiled from "Components/Forms/InputForm/InputField";
import TextAreaInput from "Components/Forms/TextAreaForm/TextArea";
import FileUpload from "Pages/WorkInformation/FileUpload/FileUpload";
import { useState } from "react";
import ModalRequestAndAddProject from "Components/ModalRequestAndAddProject/ModalRequestAndAddProject";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarAlt,
  faCheckDouble,
  faPlus,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import axiosInstance from "../../axios";
import CustomReactSelect from "Components/Forms/ReactSelect/ReactSelect";
import moment from "moment";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import {  Link, useNavigate, useSearchParams } from "react-router-dom";
import { doc, getDoc, collection, addDoc, updateDoc,arrayRemove, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import { uploadImage } from "../../utils/imageUpload";
import { FieldArray, Formik,Form } from "formik";

import WorkHeaderInfo from "Pages/WorkInformation/WorkHeaderInfo/WorkHeaderInfo";
import SliderUploader from "Pages/WorkInformation/FileUpload/SliderUploader";
import ImageUploader from "./ImageUploader";

const MyProjects = () => {
  const { t, i18n } = useTranslation(); // Initialize the useTranslation hook
  const [searchParams] = useSearchParams();
  const editId = searchParams.get("edit");

  const [documentData, setDocumentData] = useState(null);
  const [itemsOrderr, setItemsOrder] = useState([]); // Translated options
  const [icon,setIcon] = useState();
  const [firstImage,setfirstImage] = useState();
  const [secondImage,setsecondImage] = useState();

  // Existing image URLs
  const [existingIconUrl, setExistingIconUrl] = useState(null);
  const [existingFirstImageUrl, setExistingFirstImageUrl] = useState(null);
  const [existingSecondImageUrl, setExistingSecondImageUrl] = useState(null);

  // FORM SUBMIT
  const validationSchema = Yup.object().shape({
    title: Yup.string().required(t("required")),
    homeTxt: Yup.string().required(t("required")),
    firstTitle: Yup.string().required(t("required")),
    firstText: Yup.string().required(t("required")),
 
    firstFeat: Yup.array().of(Yup.string().required(t("required"))),
    secondFeat: Yup.array().of(Yup.string().required(t("required"))),
    homeFeat: Yup.array().of(Yup.string().required(t("required"))),


  });

  const [initialValues, setInitialValues] = useState({
    title: '',
    homeTxt: '',
    firstTitle: '',
    firstText: '',
    secondtext: '',
    secondTitle: '',
    firstFeat: [],
    secondFeat:[],
    homeFeat:[]
  });
  const [Fetchloading, setFetchloading] = useState(false);

  const handleDelete = async (index) => {
    const fileToDelete = selectedFiles[index];
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
  
    setSelectedFiles(updatedFiles);
  
    try {
      // Remove download URL from Firestore
      const docRef = doc(db, "OurClinc", "images"); // Document path: "OurClinic/images"
      await updateDoc(docRef, {
        urls: arrayRemove(fileToDelete.downloadURL),
      });
  
      toast.success(t("FileDeletedSuccessfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deleting file:", error);
      toast.error(t("FileDeletionFailed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };
  
  
  const [City, setCity] = useState();
  const [loading, setloading] = useState(false);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFilesError, setSelectedFilesError] = useState(false);
  const [selectedFiles2, setSelectedFiles2] = useState([]);
  const [selectedFilesError2, setSelectedFilesError2] = useState(false);
  const [SelectedCategory, setSelectedCategory] = useState();
  const [SelectedCity, setSelectedCity] = useState();
  const [SelectedCategoryError, setSelectedCategoryError] = useState();
  const [SelectedCityError, setSelectedCityError] = useState();
  const [items, setItems] = useState(["contractor", "advisor", "provider"]); // Translated options
  const type = useSelector((state) => state.auth.type);
  useEffect(() => {
    const fetchExistingImages = async () => {
      try {
        const docRef = doc(db, "OurService", "services"); // Document path: "OurClinic/images"
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
        
          console.log("Existing images:", docSnap.data());
          const imagesCollectionRef = collection(docRef, "Cards");
          const imagesCollectionSnap = await getDocs(imagesCollectionRef);
         
          imagesCollectionSnap.forEach((doc) => {
            console.log(doc.data)
            console.log(doc.id)
          });

        }
      } catch (error) {
        console.error("Error fetching existing images:", error);
      }
    };

    fetchExistingImages();
  }, []);
  // OEPN AND CLOSE MODAL
  const [showModal, setShowModalSuccess] = useState(false);
  // CLOSE MODAL
  const router = useNavigate();
  const handleCloseModal = () => {
    setShowModalSuccess(false);
    router("/home");
  };
  // OPEN MODAL
  const handleOpenModalSuccess = () => {
    setShowModalSuccess(true);
  };

  // ADD CLASS ACTIVE
  const [activeItem, setActiveItem] = useState(0);

  const handleItemClick = (index) => {
    setActiveItem(index);
  };

  const handleSubmit = async (values) => {
    setloading(true);
  
    let iconUrl = existingIconUrl;
    let firstImageUrl = existingFirstImageUrl;
    let secondImageUrl = existingSecondImageUrl;
  
    try {
      // Upload files and generate URLs if they are newly uploaded
      const uploadPromises = [];
      if (icon && icon.file) {
        uploadPromises.push(
          (async () => {
            try {
              iconUrl = await uploadImage(icon.file);
            } catch (error) {
              console.error("Icon upload error:", error);
              throw error;
            }
          })()
        );
      }
      if (firstImage && firstImage.file) {
        uploadPromises.push(
          (async () => {
            try {
              firstImageUrl = await uploadImage(firstImage.file);
            } catch (error) {
              console.error("First image upload error:", error);
              throw error;
            }
          })()
        );
      }
      if (secondImage && secondImage.file) {
        uploadPromises.push(
          (async () => {
            try {
              secondImageUrl = await uploadImage(secondImage.file);
            } catch (error) {
              console.error("Second image upload error:", error);
              throw error;
            }
          })()
        );
      }
  
      await Promise.all(uploadPromises);
  
      const docData = {
        iconUrl,
        firstImageUrl,
        ...values,
        secondImageUrl,
        createDate: new Date().toISOString(), // Add create date
      };
  
      Object.keys(docData).forEach((key) => {
        if (docData[key] === undefined) {
          delete docData[key];
        }
      });
  
      if (editId) {
        const docRef = doc(db, "OurService", "services", "Cards", editId);
        await updateDoc(docRef, docData);
        toast.success("Updated successfully");
        router("/myProjects");
      } else {
        // Add the document to Firestore
        const collectionRef = collection(db, "OurService", "services", "Cards");
        const docRef = await addDoc(collectionRef, docData);
        console.log("New card added with ID:", docRef.id);
        toast.success("Added successfully");
        router("/myProjects");
      }
    } catch (error) {
      console.error("Error saving document:", error);
      toast.error("Failed to save document.");
    } finally {
      setloading(false);
    }
  };
  
  
  
  useEffect(() => {
    const fetchDocument = async () => {
      try {
        setFetchloading(true);
        if (editId) {
          const docRef = doc(db, "OurService", "services", "Cards", editId);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const data = docSnap.data();
            const tempObj = {
              title: data.title || "",
              homeTxt: data.homeTxt || "",
              firstTitle: data.firstTitle || "",
              firstText: data.firstText || "",
              secondtext: data.secondtext || "",
              secondTitle: data.secondTitle || "",
              firstFeat: data.firstFeat || [],
              secondFeat: data.secondFeat || [],
              homeFeat: data.homeFeat || [],
            };
            setInitialValues(tempObj);
            setExistingIconUrl(data.iconUrl || null);
            setExistingFirstImageUrl(data.firstImageUrl || null);
            setExistingSecondImageUrl(data.secondImageUrl || null);
          }
        } else {
          const docRef = doc(db, "OurClinc", "text");
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            console.log("Document data:", docSnap.data());
            setDocumentData(docSnap.data());
            const tempObj = {
              title: docSnap.data().title || "",
              homeTxt: docSnap.data().homeTxt || "",
              firstTitle: docSnap.data().firstTitle || "",
              firstText: docSnap.data().firstText || "",
              secondtext: docSnap.data().secondtext || "",
              secondTitle: docSnap.data().secondTitle || "",
              firstFeat: docSnap.data().firstFeat || [],
              secondFeat: docSnap.data().secondFeat || [],
              homeFeat: docSnap.data().homeFeat || [],  
            };
            console.log(docSnap.data().items);
            setItemsOrder(docSnap.data().items || []);
            setInitialValues(tempObj);
          } else {
            console.log("No such document!");
          }
        }
      } catch (err) {
        console.error("Error loading document:", err);
      } finally {
        setFetchloading(false);
      }
    };

    fetchDocument();
  }, [editId]);

  return (
    <>
      <HelmetInfo titlePage={t("addNewProject")} />{" "}
      {/* Translated page title */}
      <ModalRequestAndAddProject
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />
      <div className="project-management-request all-main">
        <div className="d-flex justify-content-end">
        <li className="nav-item">
                    <Link
                      className="text-decoration-none d-flex align-items-center gap-2 btn-main button-home button-new-project"
                      to={"/AddService"}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                      {t("add New Service")}
                    </Link>
                  </li>
        </div>
        <WorkHeaderInfo
          title={"Edit Our Clinc section"} // Translated section title
    
        />
        {/* ========== START FORM PROJECT MANAGEMENT ========== */}
        <div className="form-project-management">
        {!Fetchloading && (
        <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleBlur }) => (
          <Form>
            <div className="row g-3">
              <div className="col-12 col-md-12">
                <InputFiled
                  label={t("Section Title")}
                  name="title"
                  type="text"
                  placeholder=""
                  success
                  value={values.title}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className="col-12 col-md-12">
                <InputFiled
                  label={t("Home Text")}
                  name="homeTxt"
                  type="text"
                  placeholder=""
                  success
                  value={values.homeTxt}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className="col-12 col-md-12">
                <InputFiled
                  label={t("First Title")}
                  name="firstTitle"
                  type="text"
                  placeholder=""
                  success
                  value={values.firstTitle}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className="col-12 col-md-12">

              <h6>First Text</h6>
              <textarea
    name="firstText"
    onChange={handleChange}
    value={values.firstText}
    rows={4} // Optional: set the height of the textarea
    style={{ width: "100%", resize: "vertical" }} // Optional: customize the style
  />
  <div style={{ whiteSpace: "pre-wrap", marginTop: "10px", border: "1px solid #ccc", padding: "10px" }}>
    {values.firstText || "Your text will appear here..."}
  </div>

              
              </div>
              <div className="col-12 col-md-12">
                <InputFiled
                  label={t("Second Title")}
                  name="secondTitle"
                  type="text"
                  placeholder=""
                  success
                  value={values.secondTitle}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              </div>
              <div className="col-12 col-md-12">
                <h6>Second Text</h6>
              <textarea
    name="secondtext"
    onChange={handleChange}
    value={values.secondtext}
    rows={4} // Optional: set the height of the textarea
    style={{ width: "100%", resize: "vertical" }} // Optional: customize the style
  />
  <div style={{ whiteSpace: "pre-wrap", marginTop: "10px", border: "1px solid #ccc", padding: "10px" }}>
    {values.secondtext || "Your text will appear here..."}
  </div>


             
              </div>
      
              {/* First Features */}
              <div className="col-12 col-md-12">
                <h4>{t("First Features")}</h4>
                <FieldArray name="firstFeat">
                  {({ insert, remove, push }) => (
                    <>
                      {values.firstFeat?.length > 0 &&
                        values.firstFeat.map((feat, index) => (
                          <div className="row align-items-center" key={index}>
                            <div className="col-10">
                              <InputFiled
                                label={`Feature ${index + 1}`}
                                name={`firstFeat[${index}]`}
                                type="text"
                                placeholder=""
                                success
                                value={feat}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                            </div>
                            <div className="col-2">
                              <button
                                type="button"
                                className="btn-main trashbtn w-100 mt-3"
                                onClick={() => remove(index)}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          </div>
                        ))}
                      <div className="col-2">
                        <button
                          type="button"
                          className="btn-main w-100 mt-3"
                          onClick={() => push('')}
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </button>
                      </div>
                    </>
                  )}
                </FieldArray>
              </div>
      
              {/* Second Features */}
              <div className="col-12 col-md-12">
                <h4>{t("Second Features")}</h4>
                <FieldArray name="secondFeat">
                  {({ insert, remove, push }) => (
                    <>
                      {values.secondFeat?.length > 0 &&
                        values.secondFeat.map((feat, index) => (
                          <div className="row align-items-center" key={index}>
                            <div className="col-10">
                              <InputFiled
                                label={`Feature ${index + 1}`}
                                name={`secondFeat[${index}]`}
                                type="text"
                                placeholder=""
                                success
                                value={feat}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                            </div>
                            <div className="col-2">
                              <button
                                type="button"
                                className="btn-main trashbtn w-100 mt-3"
                                onClick={() => remove(index)}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          </div>
                        ))}
                      <div className="col-2">
                        <button
                          type="button"
                          className="btn-main w-100 mt-3"
                          onClick={() => push('')}
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </button>
                      </div>
                    </>
                  )}
                </FieldArray>
              </div>
      
              {/* Home Features */}
              <div className="col-12 col-md-12">
                <h4>{t("Home Features")}</h4>
                <FieldArray name="homeFeat">
                  {({ insert, remove, push }) => (
                    <>
                      {values.homeFeat?.length > 0 &&
                        values.homeFeat.map((feat, index) => (
                          <div className="row align-items-center" key={index}>
                            <div className="col-10">
                              <InputFiled
                                label={`Feature ${index + 1}`}
                                name={`homeFeat[${index}]`}
                                type="text"
                                placeholder=""
                                success
                                value={feat}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                            </div>
                            <div className="col-2">
                              <button
                                type="button"
                                className="btn-main trashbtn w-100 mt-3"
                                onClick={() => remove(index)}
                              >
                                <FontAwesomeIcon icon={faTrash} />
                              </button>
                            </div>
                          </div>
                        ))}
                      <div className="col-2">
                        <button
                          type="button"
                          className="btn-main w-100 mt-3"
                          onClick={() => push('')}
                        >
                          <FontAwesomeIcon icon={faPlus} />
                        </button>
                      </div>
                    </>
                  )}
                </FieldArray>
              </div>
              <ImageUploader setFile={setIcon} title={"upload Icon"} />
              {existingIconUrl && !icon && (
                <div className="text-center mb-3 d-flex flex-column align-items-center gap-1">
                  <img src={existingIconUrl} alt="Current Icon" style={{ width: "60px", height: "auto" }} />
                  <button 
                    type="button" 
                    className="btn btn-danger btn-sm"
                    onClick={() => setExistingIconUrl(null)}
                  >
                    <FontAwesomeIcon icon={faTrash} className="me-1" /> Remove Current Icon
                  </button>
                </div>
              )}
              <ImageUploader setFile={setfirstImage} title={"upload first image"} />
              {existingFirstImageUrl && !firstImage && (
                <div className="text-center mb-3 d-flex flex-column align-items-center gap-1">
                  <img src={existingFirstImageUrl} alt="Current First Image" style={{ width: "100px", height: "auto" }} />
                  <button 
                    type="button" 
                    className="btn btn-danger btn-sm"
                    onClick={() => setExistingFirstImageUrl(null)}
                  >
                    <FontAwesomeIcon icon={faTrash} className="me-1" /> Remove Current First Image
                  </button>
                </div>
              )}
              <ImageUploader setFile={setsecondImage} title={"upload second image"} />
              {existingSecondImageUrl && !secondImage && (
                <div className="text-center mb-3 d-flex flex-column align-items-center gap-1">
                  <img src={existingSecondImageUrl} alt="Current Second Image" style={{ width: "100px", height: "auto" }} />
                  <button 
                    type="button" 
                    className="btn btn-danger btn-sm"
                    onClick={() => setExistingSecondImageUrl(null)}
                  >
                    <FontAwesomeIcon icon={faTrash} className="me-1" /> Remove Current Second Image
                  </button>
                </div>
              )}
 
              <button className="btn-main w-100" type="submit">
                {loading ? (
                  <span className="loader"></span>
                ) : (
                  editId ? "Edit Service" : "Add Service"
                )}
              </button>
            </div>
          </Form>
        )}
      </Formik>
      )}
        </div>
        {/* ========== END FORM PROJECT MANAGEMENT ========== */}
      </div>
    
    </>
  );
};

export default MyProjects;
